import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {PolicyDocument} from '../../shared/policy/policy-document';

@Injectable({providedIn: 'root'})
export class PolicyService {
  private readonly _http = inject(HttpClient);
  private readonly _translate = inject(TranslateService);

  load(): Observable<PolicyDocument> {
    const lang = (this._translate.currentLang() ?? '').toLowerCase() === 'kz' ? 'kz' : 'ru';
    return this._http.get<PolicyDocument>(`/assets/policy/${lang}.json`);
  }
}
